import React from 'react';
import { DESTINATION_TYPES } from '../../../containers/destination/constants/destinationTypes';
import ActivationsAPI from '../../../containers/activate/api/ActivationsAPI';
import { ActivationStatusEnum } from '../../../containers/activate/models/activation-status';
import { GlobalSearchItem, GlobalSearchRegistryItem } from '../../interfaces/global-search';
import { TARGET_TYPES } from '../../../containers/activate-target/models/target-type';
import { GenericListItemContent, GenericListItemContentProps } from './GenericListItemContent/GenericListItemContent';
import { GlobalSearchEntityCommonData } from './interfaces/global-search-entity';
import { _activationStatusService } from '../../../core/services/activation-status.service';

export interface GlobalSearchActivationData {
  target: GlobalSearchEntityCommonData;
  warehouse: GlobalSearchEntityCommonData;
  status: string;
}

export const GLOBAL_SEARCH_ACTIVATION_KEY = 'activations';

export const GlobalSearchActivationRegistry: GlobalSearchRegistryItem<GlobalSearchActivationData> = {
  key: GLOBAL_SEARCH_ACTIVATION_KEY,
  title: 'Activations',
  sortOrder: 4,
  maxItemsWhenNoFiltersApplied: 2,
  doNotRender: () => !_activationStatusService?.shouldShowActivation(),
  filters: [
    {
      value: GLOBAL_SEARCH_ACTIVATION_KEY,
      label: 'Activations'
    }
  ],
  viewAllRoute: '/activation',
  inMemoryFiltering: true,
  dataResolver: () => ActivationsAPI.getActivations()
      .then(res => {
        const activations = res.data.map(GlobalSearchActivationFactory);
        return [...activations];
      }),
  renderItem: (item) => {
    const props: GenericListItemContentProps = {
      suffixIcon: item.icon,
      primaryText: item.data.warehouse.name,
      primaryLogoTooltip: item.data.warehouse.displayType,
      primaryLogoProps: {
        logoURL: item.data.warehouse.logoUrl,
        darkModeLogoURL: item.data.warehouse.darkModeLogoUrl,
        primaryColor: DESTINATION_TYPES[item.data.warehouse.type]?.primaryColor,
        darkModePrimaryColor: DESTINATION_TYPES[item.data.warehouse.type]?.darkModePrimaryColor
      },
      logoConnector: true,
      logoConnectorColor: item.data.status,
      secondaryText: item.data.target.name,
      secondaryLogoProps: {
        logoURL: item.data.target.logoUrl,
        darkModeLogoURL: item.data.target.darkModeLogoUrl,
        primaryColor: TARGET_TYPES[item.data.target.type]?.primaryColor,
        darkModePrimaryColor: TARGET_TYPES[item.data.target.type]?.darkModePrimaryColor
      },
      secondaryLogoTooltip: item.data.target.displayType
    };

    return (
      <GenericListItemContent {...props} />
    );
  }
};

export function GlobalSearchActivationFactory(
  rawActivation: any
): GlobalSearchItem<GlobalSearchActivationData> {
  let status = ActivationStatusEnum[rawActivation.status]?.colorType;

  if (rawActivation.status === 'OK') {
    status = ActivationStatusEnum[rawActivation.state].colorType;
  }

  return {
    data: {
      warehouse: {
        name: rawActivation.name,
        type: rawActivation.warehouse.type,
        displayType: rawActivation.warehouse.type_display_name,
        logoUrl: rawActivation.warehouse.type_logo_url,
        darkModeLogoUrl:
          rawActivation.warehouse.type_dark_mode_logo_url ?? rawActivation.warehouse.type_logo_url
      },
      target: {
        name: rawActivation.target.name,
        type: rawActivation.target.type,
        displayType: rawActivation.target.type_display_name,
        logoUrl: rawActivation.target.type_logo_url,
        darkModeLogoUrl: rawActivation.target.type_dark_mode_logo_url ?? rawActivation.target.type_logo_url,
      },
      status,
    },
    key: `${rawActivation.warehouse.type}-activation-${rawActivation.seq_id}`,
    name: rawActivation.name,
    exitURL: `/activation/${rawActivation.seq_id}/overview`,
    icon: 'activate',
    searchKeywords: [
      rawActivation.name,
      rawActivation.warehouse.type,
      rawActivation.warehouse.type_display_name
    ]
  };
}
